module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name} y #{Name.last_name}",
  "#{Name.last_name} #{Name.last_name} #{suffix}",
  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/company/name.js
 ** module id = 598
 ** module chunks = 0
 **/